import { render, staticRenderFns } from "./AutomaticPaymentsOverview.vue?vue&type=template&id=28444aa0&"
import script from "./AutomaticPaymentsOverview.vue?vue&type=script&lang=ts&"
export * from "./AutomaticPaymentsOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports